import { FieldRendererProps } from "@crispico/foundation-react/entity_crud/fieldRenderersEditors";
import { Icon } from "semantic-ui-react";

export const FlightDepartureFieldRenderer = (props: FieldRendererProps) => {
    const value: boolean = props.value != null && props.value as boolean;
    const colors: { backgroundColor: string | undefined, color: string | undefined, bulletColor: string | undefined } = props.fieldDescriptor.getFieldColors(props.value);
    const color = colors.backgroundColor !== undefined ? colors.backgroundColor : (colors.bulletColor !== undefined ? colors.bulletColor : colors.color);
    return <div><Icon name="plane" style={{ transform: "rotate(" + (value ? "-" : "") + "45deg)" + (value ? "" : "translate(25%,-25%)"), color: color}} /></div>
}
